// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f843eb5c","199":"079b9e0f","274":"b5d35181","645":"6d82b36b"}[chunkId] + ".chunk.js";
};